import { modifyPathPrefix } from './';

export const mapMenu = (data) => {
  const filteredMenu = data?.menuItems?.nodes?.filter(
    (menuItem) => !menuItem.parentId
  );

  return filteredMenu?.map((menu) => {
    let tempContent = [];
    return {
      name: menu.label,
      content: menu.childItems?.nodes?.map((subMenu, index) => {
        if (
          Array.isArray(subMenu.childItems?.nodes) &&
          subMenu.childItems?.nodes?.length
        ) {
          return {
            category: subMenu.label,
            items: subMenu.childItems.nodes.map((subSubMenu) => ({
              title: subSubMenu.label,
              link: modifyPathPrefix(subSubMenu.path),
            })),
          };
        }

        tempContent.push({
          title: subMenu.label,
          link: modifyPathPrefix(subMenu.path),
        });

        return (
          index === menu.childItems.nodes.length - 1 && { items: tempContent }
        );
      }),
    };
  });
};
